<div class="edit-user">
  <div class="container">
    <div class="d-flex justify-content-between container" *ngIf="isInitialised">
      <h2>
        {{ companyName }}
        <a
          href="https://www.google.com/maps/search/{{
            urlFriendlyCompanyName()
          }}"
          target="_blank"
          class="clickable-map"
          ><mat-icon fontSet="fa" fontIcon="fa-map-marked-alt"></mat-icon
        ></a>
      </h2>
      <div>
        <button type="button" (click)="back()" class="btn btn-main btn-back">
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="isInitialised">
      <div>
        <form
          [formGroup]="companyForm"
          role="form"
          autocomplete="off"
          id="formContactEdit"
          novalidate=""
          (submit)="save()"
        >
          <mat-card class="mat-elevation-z0 padding">
            <div class="form-title font-weight-bold">Algemeen</div>

            <mat-checkbox
              class="justify-content-between"
              formControlName="dataCorrect"
              >Goedgekeurd
            </mat-checkbox>

            <mat-checkbox
              class="justify-content-between new-portal-flag"
              formControlName="newPortalAccess"
              >Nieuw portaal
            </mat-checkbox>

            <div class="d-flex push-down justify-content-between">
              <mat-form-field class="form-field no-margin" appearance="outline">
                <mat-label>Klantnaam</mat-label>
                <input
                  matInput
                  type="text"
                  required
                  formControlName="regularName"
                  [placeholder]="'Klantnaam'"
                />
                <mat-error
                  *ngIf="companyForm.controls.regularName.errors?.required"
                  >Klantnaam is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Facturatienaam</mat-label>
                <input
                  matInput
                  type="text"
                  required
                  formControlName="name"
                  [placeholder]="'Facturatienaam'"
                />
                <mat-error *ngIf="companyForm.controls.name.errors?.required"
                  >Facturatienaam is vereist
                </mat-error>
              </mat-form-field>
            </div>

            <div class="d-flex push-down justify-content-between">
              <mat-form-field class="form-field no-margin" appearance="outline">
                <mat-label>Telefoonnummer</mat-label>
                <input
                  matInput
                  type="text"
                  required
                  formControlName="telephone"
                  [value]="
                    companyForm.controls.telephone.value | asFormatPhoneNumber
                  "
                  [placeholder]="'Telefoonnummer'"
                />
                <mat-error
                  *ngIf="companyForm.controls.telephone.errors?.required"
                  >Telefoonnummer is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Algemeen e-mailadres</mat-label>
                <input
                  matInput
                  type="text"
                  email
                  required
                  formControlName="generalEmail"
                  [placeholder]="'Algemeen e-mailadres'"
                />
                <mat-error
                  *ngIf="companyForm.controls.generalEmail.errors?.required"
                  >Algemeen e-mailadres is vereist
                </mat-error>
              </mat-form-field>
            </div>

            <div class="d-flex justify-content-between">
              <mat-form-field class="form-field no-margin" appearance="outline">
                <mat-label>Klant sinds</mat-label>
                <input
                  matInput
                  formControlName="customerSince"
                  [matDatepicker]="customerSincePicker"
                  placeholder="Selecteer een datum"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="customerSincePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #customerSincePicker></mat-datepicker>
                <mat-error
                  *ngIf="companyForm.controls.customerSince.errors?.required"
                  >Klant sinds is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>BTW-nummer</mat-label>
                <input
                  matInput
                  type="text"
                  [specialCharacters]="['B', 'E', '\.']"
                  [validation]="true"
                  mask="BE0000.000.000"
                  formControlName="vatNumber"
                  [placeholder]="'BTW-nummer'"
                />
                <mat-error
                  *ngIf="companyForm.controls.vatNumber.errors?.vatNumberFormat"
                  >Vul 0 gevolgd door negen cijfers in a.u.b.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="d-flex justify-content-between">
              <mat-form-field
                class="form-field no-margin max-half-width"
                appearance="outline"
              >
                <mat-label>Betalingscondities</mat-label>
                <mat-select
                  matInput
                  placeholder="Betalingscondities"
                  formControlName="paymentTerm"
                  [compareWith]="comparePaymentTerms"
                  required
                >
                  <mat-option
                    *ngFor="let option of paymentTermOptions"
                    [value]="option.paymentTerm"
                  >
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="companyForm.controls.paymentTerm.errors?.required"
                  >Betalingscondities zijn vereist
                </mat-error>
              </mat-form-field>

              <mat-checkbox
                class="flexer padding-left justify-content-between push-down-row"
                formControlName="pendingInvoices"
                >Openstaande facturen
              </mat-checkbox>
            </div>

            <div class="d-flex justify-content-between">
              <yes-no
                class="invoice-yes-no"
                [title]="'Facturatie per email:'"
                [neverShowExtraInstructions]="true"
                [nullable]="false"
                [nullIsFalse]="true"
                [value]="companyForm.controls.invoicePerEmail.value"
                [disabled]="false"
                [client]="false"
                (answer)="invoicePerEmailChange($event)"
              ></yes-no>
              <mat-form-field
                *ngIf="companyForm.controls.invoicePerEmail.value"
                class="max-half-width form-field"
                appearance="outline"
              >
                <mat-label>Facturatie e-mailadres</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="invoicingEmail"
                  [placeholder]="'Facturatie e-mailadres'"
                />
                <mat-error
                  *ngIf="companyForm.controls.invoicingEmail.errors?.required"
                  >Facturatie e-mailadres is vereist
                </mat-error>
              </mat-form-field>
            </div>

            <div class="d-flex justify-content-between">
              <mat-checkbox
                class="justify-content-between push-down-row half-width"
                formControlName="immo"
                >Immoklant
              </mat-checkbox>
              <div class="padding-left flexer d-flex">
                <mat-checkbox
                  class="two-checkbox-flex justify-content-between push-down-row"
                  formControlName="immoscoop"
                  >Immoscoop
                </mat-checkbox>
                <mat-checkbox
                  class="two-checkbox-flex justify-content-between push-down-row"
                  formControlName="spotto"
                  >Spotto
                </mat-checkbox>
              </div>
            </div>

            <div class="d-flex justify-content-between">
              <mat-checkbox
                class="justify-content-between push-down-row max-half-width"
                formControlName="isRetailer"
                >Is retailer
              </mat-checkbox>
            </div>

            <div class="d-flex justify-content-between push-down-row">
              <mat-form-field
                class="form-field no-margin max-half-width"
                appearance="outline"
              >
                <mat-label>Activiteit</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="activity"
                  [placeholder]="'Activiteit'"
                />
              </mat-form-field>

              <mat-checkbox
                class="flexer padding-left justify-content-between push-down-row"
                formControlName="mailNewsletter"
                >Nieuwsbrief
              </mat-checkbox>
            </div>

            <div class="d-flex push-down justify-content-between">
              <mat-form-field class="form-field no-margin" appearance="outline">
                <mat-label>Openingsuren</mat-label>
                <textarea
                  matInput
                  [placeholder]="'Openingsuren'"
                  cdkTextareaAutosize
                  formControlName="openHours"
                >
                </textarea>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Info</mat-label>
                <textarea
                  matInput
                  [placeholder]="'Info'"
                  cdkTextareaAutosize
                  formControlName="info"
                >
                </textarea>
              </mat-form-field>
            </div>

            <div class="d-flex push-down justify-content-between">
              <mat-form-field
                class="form-field no-margin max-half-width"
                appearance="outline"
              >
                <mat-label>Website</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="website"
                  [placeholder]="'Website'"
                />
              </mat-form-field>
              <mat-form-field
                class="form-field max-half-width"
                appearance="outline"
              >
                <mat-label>Kortingsgroep</mat-label>
                <mat-select
                  matInput
                  placeholder="Kortingsgroep"
                  formControlName="discountGroup"
                  [compareWith]="compareText"
                >
                  <mat-option
                    *ngFor="let option of discountGroupOptions"
                    [value]="option"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="companyForm.controls.discountGroup.errors?.required"
                  >Kortingsgroep vereist
                </mat-error>
              </mat-form-field>
            </div>

            <div class="d-flex push-down justify-content-between">
              <mat-form-field
                class="form-field no-margin max-half-width"
                appearance="outline"
              >
                <mat-label>Afstand vanaf Inpress</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="distanceTo"
                  [placeholder]="'Afstand vanaf Inpress'"
                />
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Kleuren extra info</mat-label>
                <textarea
                  matInput
                  cdkTextareaAutosize
                  formControlName="colorsExtraInfo"
                >
                </textarea>
              </mat-form-field>
            </div>

            <div class="d-flex push-down justify-content-between">
              <mat-form-field
                class="form-field no-margin max-half-width"
                appearance="outline"
              >
                <mat-label>CustomerExID</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="externalId"
                  [placeholder]="'CustomerExID'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field
                class="form-field max-half-width"
                appearance="outline"
              >
                <mat-label>Partner integraties</mat-label>
                <mat-select
                  formControlName="partnerIntegrations"
                  multiple
                  placeholder="Partner integraties"
                >
                  <mat-option
                    *ngFor="let option of partnerIntegrationOptions"
                    [value]="option.value"
                  >
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="form-title font-weight-bold">Algemeen adres</div>

            <div class="d-flex justify-content-between">
              <mat-form-field class="form-field no-margin" appearance="outline">
                <mat-label>Straat, huisnummer, bus</mat-label>
                <input
                  matInput
                  type="text"
                  required
                  formControlName="generalLine1"
                  [placeholder]="'Straat, huisnummer, bus'"
                />
                <mat-error
                  *ngIf="companyForm.controls.generalLine1.errors?.required"
                  >Straat, huisnummer, bus is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Gemeente</mat-label>
                <input
                  matInput
                  type="text"
                  required
                  formControlName="generalCity"
                  [placeholder]="'Gemeente'"
                />
                <mat-error
                  *ngIf="companyForm.controls.generalCity.errors?.required"
                  >Gemeente is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Postcode</mat-label>
                <input
                  matInput
                  type="text"
                  required
                  formControlName="generalPostalCode"
                  [placeholder]="'Postcode'"
                />
                <mat-error
                  *ngIf="
                    companyForm.controls.generalPostalCode.errors?.required
                  "
                  >Postcode is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Provincie</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="generalProvince"
                  [placeholder]="'Provincie'"
                />
              </mat-form-field>
              <mat-form-field
                class="flex-grow-1 form-field address-country"
                appearance="outline"
              >
                <mat-label>Land</mat-label>
                <mat-select
                  matInput
                  type="text"
                  formControlName="generalCountry"
                  [compareWith]="compareCountries"
                  [placeholder]="'Land'"
                >
                  <mat-option
                    *ngFor="let country of countryOptions"
                    [value]="country.value"
                  >
                    {{ country.label }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="companyForm.controls.generalCountry.errors?.required"
                  >Land is vereist
                </mat-error>
              </mat-form-field>
            </div>

            <mat-checkbox
              class="justify-content-between margin-bottom"
              formControlName="otherInvoicingAddress"
              >Ander facturatieadres
            </mat-checkbox>

            <div
              *ngIf="companyForm.controls.otherInvoicingAddress.value"
              class="form-title-top-margin font-weight-bold"
            >
              Facturatieadres
            </div>

            <div
              *ngIf="companyForm.controls.otherInvoicingAddress.value"
              class="d-flex justify-content-between"
            >
              <mat-form-field class="form-field no-margin" appearance="outline">
                <mat-label>Straat, huisnummer, bus</mat-label>
                <input
                  matInput
                  type="text"
                  required
                  formControlName="invoicingLine1"
                  [placeholder]="'Straat, huisnummer, bus'"
                />
                <mat-error
                  *ngIf="companyForm.controls.invoicingLine1.errors?.required"
                  >Straat, huisnummer, bus is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Gemeente</mat-label>
                <input
                  matInput
                  type="text"
                  required
                  formControlName="invoicingCity"
                  [placeholder]="'Gemeente'"
                />
                <mat-error
                  *ngIf="companyForm.controls.invoicingCity.errors?.required"
                  >Gemeente is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Postcode</mat-label>
                <input
                  matInput
                  type="text"
                  required
                  formControlName="invoicingPostalCode"
                  [placeholder]="'Postcode'"
                />
                <mat-error
                  *ngIf="
                    companyForm.controls.invoicingPostalCode.errors?.required
                  "
                  >Postcode is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Provincie</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="invoicingProvince"
                  [placeholder]="'Provincie'"
                />
              </mat-form-field>
              <mat-form-field
                class="form-field address-country"
                appearance="outline"
              >
                <mat-label>Land</mat-label>
                <mat-select
                  matInput
                  type="text"
                  formControlName="invoicingCountry"
                  [compareWith]="compareCountries"
                  [placeholder]="'Land'"
                >
                  <mat-option
                    *ngFor="let country of countryOptions"
                    [value]="country.value"
                  >
                    {{ country.label }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="companyForm.controls.invoicingCountry.errors?.required"
                  >Land is vereist
                </mat-error>
              </mat-form-field>
            </div>

            <br *ngIf="!companyForm.controls.otherInvoicingAddress.value" />

            <mat-checkbox
              class="justify-content-between margin-bottom"
              formControlName="otherDeliveryAddress"
              >Ander leveringsadres
            </mat-checkbox>

            <div
              *ngIf="companyForm.controls.otherDeliveryAddress.value"
              class="form-title-top-margin font-weight-bold"
            >
              Leveringsadres
            </div>

            <div
              *ngIf="companyForm.controls.otherDeliveryAddress.value"
              class="d-flex justify-content-between"
            >
              <mat-form-field class="form-field no-margin" appearance="outline">
                <mat-label>Straat, huisnummer, bus</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="deliveryLine1"
                  required
                  [placeholder]="'Straat, huisnummer, bus'"
                />
                <mat-error
                  *ngIf="companyForm.controls.deliveryLine1.errors?.required"
                  >Straat, huisnummer, bus is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Gemeente</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="deliveryCity"
                  required
                  [placeholder]="'Gemeente'"
                />
                <mat-error
                  *ngIf="companyForm.controls.deliveryCity.errors?.required"
                  >Gemeente is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Postcode</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="deliveryPostalCode"
                  required
                  [placeholder]="'Postcode'"
                />
                <mat-error
                  *ngIf="
                    companyForm.controls.deliveryPostalCode.errors?.required
                  "
                  >Postcode is vereist
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Provincie</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="deliveryProvince"
                  [placeholder]="'Provincie'"
                />
              </mat-form-field>
              <mat-form-field
                class="form-field address-country"
                appearance="outline"
              >
                <mat-label>Land</mat-label>
                <mat-select
                  matInput
                  type="text"
                  formControlName="deliveryCountry"
                  [compareWith]="compareCountries"
                  [placeholder]="'Land'"
                >
                  <mat-option
                    *ngFor="let country of countryOptions"
                    [value]="country.value"
                  >
                    {{ country.label }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="companyForm.controls.deliveryCountry.errors?.required"
                  >Land is vereist
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-title font-weight-bold">Contacten</div>

            <div
              *ngIf="
                displayedContacts == null || displayedContacts.length === 0
              "
            >
              <p class="no-margin padding-bottom">
                Geen contacten gedefinieerd
              </p>
            </div>
            <div
              *ngIf="displayedContacts != null && displayedContacts.length > 0"
              class="table-container panel"
            >
              <div class="example-table-container">
                <table
                  mat-table
                  [dataSource]="displayedContacts"
                  class="example-table"
                  matSort
                  matSortActive="id"
                  matSortDisableClear="true"
                  matSortDirection="asc"
                >
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="header-text">
                      <div class="d-flex">
                        <div class="text-middle" [mat-sort-header]="">
                          <b>Naam</b>
                        </div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="table-text">
                      {{ row.firstName }} {{ row.lastName }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="phone">
                    <th mat-header-cell *matHeaderCellDef class="header-text">
                      <div class="d-flex">
                        <div class="text-middle" [mat-sort-header]="">
                          <b>Telefoonnummer</b>
                        </div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="table-text">
                      {{ getContactTelephone(row) }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="mobile">
                    <th mat-header-cell *matHeaderCellDef class="header-text">
                      <div class="d-flex">
                        <div class="text-middle" [mat-sort-header]="">
                          <b>Gsm</b>
                        </div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="table-text">
                      {{ getContactMobile(row) }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef class="header-text">
                      <div class="d-flex">
                        <div class="text-middle extra-right">
                          <b>Functie</b>
                        </div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="table-text">
                      {{ getTypeLabel(row.type) }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="lastLogin">
                    <th mat-header-cell *matHeaderCellDef class="header-text">
                      <div class="d-flex">
                        <div class="text-middle extra-right">
                          <b>Laatste log</b>
                        </div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="table-text">
                      <ng-container
                        *ngIf="row.lastLogin != null; else loginBtn"
                      >
                        {{
                          row.lastLogin
                            | date
                              : 'dd/MM/yyyy HH:mmu'
                              : 'Europe/Brussels'
                              : 'nl-BE'
                        }}
                      </ng-container>
                      <ng-template #loginBtn>
                        <button
                          *ngIf="
                            row.emails?.length > 0 &&
                            row.emails[0].email != null
                          "
                          type="button"
                          (click)="login($event, row)"
                          mat-button
                          class="inline-button small"
                          [disabled]="
                            !(
                              row.emails?.length > 0 &&
                              row.emails[0].email != null
                            )
                          "
                        >
                          Login
                        </button>
                      </ng-template>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="active">
                    <th mat-header-cell *matHeaderCellDef class="header-text">
                      <div class="d-flex">
                        <div class="text-middle extra-right">
                          <b>A</b>
                        </div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="table-text">
                      <mat-checkbox
                        [checked]="row.lastLogin != null"
                        [disabled]="true"
                      ></mat-checkbox>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="email">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="header-text header-text--email"
                    >
                      <div class="d-flex">
                        <div class="text-middle extra-right">
                          <b>E</b>
                        </div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="table-text">
                      <a
                        *ngIf="
                          row.emails?.length > 0 && row.emails[0].email != null
                        "
                        class="click-link"
                        href="mailto:{{ row.emails[0].email }}"
                        (click)="$event.stopPropagation()"
                      >
                        <mat-icon class="medium-icon">email</mat-icon>
                      </a>
                    </td>
                  </ng-container>

                  <!-- Impersonate Column -->
                  <ng-container matColumnDef="impersonate">
                    <th mat-header-cell *matHeaderCellDef class="header-text">
                      <div class="d-flex">
                        <div class="text-middle extra-right"><b>I</b></div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="table-text">
                      <mat-icon
                        class="impersonate-contact-icon clickable"
                        [class.impersonate-disabled]="row.contactUserId == null"
                        [matTooltip]="
                          row.contactUserId != null
                            ? 'Nabootsen'
                            : 'Nabootsen niet mogelijk, geen gebruiker gelinkt'
                        "
                        [style.cursor]="
                          row.contactUserId == null ? 'default' : 'pointer'
                        "
                        (click)="
                          $event.stopPropagation(); impersonateContact(row)
                        "
                      >
                        person
                      </mat-icon>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    [routerLink]="['/contacten', row.id]"
                    mat-row
                    class="table-row clickable"
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                </table>
              </div>
            </div>
            <button
              *ngIf="company.id != null"
              type="button"
              (click)="openCompanyContactDialog()"
              mat-button
              class="inline-button"
              id="btnEditContacts"
            >
              Bewerk contacten
            </button>

            <div class="form-title font-weight-bold">Drukkleuren</div>
            <pms-color-list [inputCompany]="company"></pms-color-list>

            <div class="form-title font-weight-bold logo-section">Logo</div>
            <div>
              <div class="rounded-circle company-initials">
                <span
                  *ngIf="!this.company.logo"
                  class="company-initials rounded-circle in-the-middle no-margin"
                >
                  {{ getInitials() }}
                </span>

                <div *ngIf="this.company.logo" class="in-the-middle">
                  <img
                    class="rounded-circle"
                    *ngIf="isImage(this.company.logo)"
                    src="/api/assets/{{ this.company.logo.uuid }}"
                    width="120px"
                    height="120px"
                  />
                </div>
              </div>

              <div class="d-flex">
                <button
                  class="btn button no-margin button-width"
                  type="button"
                  (click)="fileInput.click()"
                >
                  <span>Bestand uploaden</span>

                  <input
                    #fileInput
                    type="file"
                    style="display: none"
                    ng2FileSelect
                    [uploader]="uploader"
                    (onFileSelected)="companyLogofileAdded($event)"
                    accept=".png,.jpg,.jpeg,.pdf,image/png,image/jpg,image/jpeg,application/pdf"
                  />
                </button>
              </div>
            </div>
            <div class="form-title font-weight-bold board-images-section">
              Immobord & Kleefbord
            </div>
            <div class="d-flex render-images-container">
              <div>
                <div>
                  <div class="">
                    <div>
                      <img
                        class="image-contain"
                        [src]="
                          !!this.company.immobordImage
                            ? '/api/assets/' + this.company.immobordImage.uuid
                            : '/assets/company_placeholder.jpg'
                        "
                        width="500px"
                        height="300px"
                      />
                    </div>
                  </div>
                </div>

                <div class="d-flex upload-button">
                  <button
                    class="btn button no-margin button-width"
                    type="button"
                    (click)="fileInputImmoboard.click()"
                  >
                    <span>Immobord bestand uploaden</span>

                    <input
                      #fileInputImmoboard
                      type="file"
                      style="display: none"
                      ng2FileSelect
                      [uploader]="uploader"
                      (onFileSelected)="uploadImmoboardImage($event)"
                      accept=".png,.jpg,.jpeg,.pdf,image/png,image/jpg,image/jpeg,application/pdf"
                    />
                  </button>
                </div>
              </div>
              <div>
                <div>
                  <div class="">
                    <div>
                      <img
                        class="image-contain"
                        [src]="
                          !!this.company.kleefbordImage
                            ? '/api/assets/' + this.company.kleefbordImage.uuid
                            : '/assets/company_placeholder.jpg'
                        "
                        width="500px"
                        height="300px"
                      />
                    </div>
                  </div>
                </div>

                <div class="d-flex upload-button">
                  <button
                    class="btn button no-margin button-width"
                    type="button"
                    (click)="fileInputKleefbord.click()"
                  >
                    <span>Kleefbord bestand uploaden</span>

                    <input
                      #fileInputKleefbord
                      type="file"
                      style="display: none"
                      ng2FileSelect
                      [uploader]="uploader"
                      (onFileSelected)="uploadKleefboardImage($event)"
                      accept=".png,.jpg,.jpeg,.pdf,image/png,image/jpg,image/jpeg,application/pdf"
                    />
                  </button>
                </div>
              </div>
            </div>
          </mat-card>
        </form>

        <div class="float-right">
          <button
            type="button"
            (click)="save()"
            mat-button
            class="button"
            id="btnLogin"
          >
            Opslaan
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
